import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(adminContactName, adminContactEmail) {
  return yield oncallFetch("/api/oncall/partners/contact-details/update", {
    adminContactName,
    adminContactEmail,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/contact-details/update.js